module.exports = "https://cdn2-fs.clearscore.com/flux/images/bca626cae62fe2aa66c7352e3cfdbb42.jpg";